
document.addEventListener("DOMContentLoaded", () => {
    const menuItems = document.querySelectorAll(".site-menu .menu-item");

    menuItems.forEach(item => {
        const submenu = item.querySelector(".sub-menu");
        let timeoutId;

        const clear = () => clearTimeout(timeoutId);

        const startDelay = () => {
            timeoutId = setTimeout(() => {
                item.classList.remove("hover-delay");
            }, 200); // 0.2 sek
        };

        // Mouse enter på parent
        item.addEventListener("mouseenter", () => {
            clear();
            item.classList.add("hover-delay");
        });

        // Mouse leave på parent
        item.addEventListener("mouseleave", () => {
            startDelay();
        });

        if (submenu) {
            // Mouse enter på submenu → avbryt timeout
            submenu.addEventListener("mouseenter", clear);

            // Mouse leave på submenu → starta timeout
            submenu.addEventListener("mouseleave", startDelay);
        }
    });
});
//# sourceMappingURL=mobilemenu.js.map
